import defineReadAutoAction from '~/prix/actions/defineReadAutoAction'
import legalEntityIndicatorsReadAction from './legalEntityIndicatorsRead.action.json' assert { type: 'json' }

const legalEntityIndicatorsReadDefinition = defineReadAutoAction(
  legalEntityIndicatorsReadAction,
  'legalEntityIndicators',
)

export default legalEntityIndicatorsReadDefinition
